import React from "react";
import { Button, Container, Span } from "../../Styles/Global.Styled";
import { css } from "styled-components";
import { useNavigate } from "react-router-dom";
import Login from "../../Pages/Login";

const CartPopUp = ({setPopUp}) => {
  const navigate = useNavigate();
  return (
    <Container
      $baseStyle={css`
        /* border: 2px solid red; */
        flex-direction: column;
        padding: 0 4vh 4vh;
        gap: 2vh;
      `}
    >
      <Span
        $baseStyle={css`
          font-size: 1.25vh;
          text-align: center;
        `}
      >
        You need to be a partner to place an order. If you're already a partner,
        please log in. Otherwise, sign up to join us!
      </Span>
      <Container
        $baseStyle={css`
          flex-direction: column;
          align-items: center;
          gap: 1.5vh;
        `}
      >
        <Button
          $baseStyle={css`
            border: 2px solid ${({ theme }) => theme.main};
            color: ${({ theme }) => theme.main};
            width: 60%;
            border-radius: 12px;
            font-size: 1.5vh;
            padding: 0.35vh 0;
          `}
          onClick={() => setPopUp({isOpen:true,content:<Login setPopUp={setPopUp}/>})}
        >
          Login
        </Button>
        <Button
          $baseStyle={css`
            background-color: ${({ theme }) => theme.main};
            color: white;
            width: 60%;
            padding: 0.35vh 0;
            border-radius: 12px;
            font-size: 1.5vh;
          `}
          onClick={() => {
            setPopUp({isOpen:false,component:null})
            navigate("/register")}}
        >
          Join Us!
        </Button>
      </Container>
    </Container>
  );
};

export default CartPopUp;
